import ContinuePage from "@components/ContinuePage"

export default function HairstyleUnleashLookPage() {
  return <ContinuePage emoji="💇" translationKey="unleashLookHairstyle" />
}
